import styled from 'styled-components';

export const ValidationError = styled.div`
  color: ${({ theme }) => theme.support.textColor.error};
  margin-bottom: 1rem;
`;
